import React, { useState, useEffect, useContext, useMemo } from "react";
import { styled, useTheme } from "@mui/material/styles";
import "./Missedstyle.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import pdficon from "./../Asset/PDF.png";
import csvicon from "./../Asset/CSV.png";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Bar } from "react-chartjs-2";
import Chart from "react-apexcharts";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import axios from "axios";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import Loader from "../CommonLoader";
import { ChartContainer, BarPlot, ChartsTooltip } from "@mui/x-charts";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpSharpIcon from '@mui/icons-material/ArrowDropUpSharp';
import SquareIcon from '@mui/icons-material/Square';
import GooglePng from "../../../Icons/google.png";
import BingPng from "../../../Icons/bing.png";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Keywordbar from "./../Rightsidebar/Keywordbar";
import { useNavigate } from "react-router-dom";
import { Commonfun, datezonechange, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import Select from 'react-select';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import { Link } from "react-router-dom";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { padding } from "@mui/system";
import { Container, Grid } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";

export default function Missedopportunity() {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState([]);
  const [selectjobid, setselectjobid] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [selectval, setSelectval] = useState([]);
  const [selectsecondval, setSelectsecondval] = useState([]);
  const [menubutval, setMenubutval] = useState("1")
  const [buttnval, setButtnval] = useState("1")
  const [pagename, setPagename] = useState("Missed Opportunities")
  const [sitecardData, setSitecardData] = useState([]);
  const [internalcardData, setInternalcardData] = useState([]);
  const [seoindexData, setSeoindexData] = useState([]);
  const [seooccurData, setSeooccurData] = useState([]);
  const [latestoccurData, setLatestoccurData] = useState([]);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState("");
  const [value, setValue] = useState("1");
  const [chartvalue, setChartvalue] = useState("4");
  const [domainval, setDomainval] = useState([])
  const [reportdata, setReportdata] = useState("");
  const [reporttwodata, setReporttwodata] = useState([]);
  const [latestdataarr, setLatestdataarr] = useState([]);
  const [earlierdataarr, setEarlierdataarr] = useState([]);
  const [arrheaderdata, setArrheaderdata] = useState([]);
  const [serveritydata, setServeritydata] = useState([]);
  const [SearchEngine, SetSearchEngine] = useState("");
  const [Countryoptions, SetCountryoptions] = useState([]);
  const [Stateoptions, SetStateoptions] = useState([]);
  const [CityOptions, SetCityOptions] = useState([]);
  const [Engineoptions, SetEngineoptions] = useState([]);
  const [Country, SetCountry] = useState("");
  const [State, SetState] = useState("");
  const [City, SetCity] = useState("");
  const [statedataid, SetStatedataid] = useState("");
  const [citydataid, SetCitydataid] = useState("");
  const [autoheightval, SetAutoheightval] = useState(true)

  const [tableLoading, setTableLoading] = useState(true);

  const [AddDataTableErr, SetAddDataTableErr] = useState("");
  const [AddDataTableArray, SetAddDataTableArray] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([]);
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [campaign, Setcampaign] = useState("");
  const [campaignoption, Setcampaignoption] = useState([]);
  const [ErrorMsg, SetErrorMsg] = useState("");
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;

  const [dcampaignoption, Setdcampaignoption] = useState([]);
  const [dselectjobid, setdselectjobid] = useState([])
  const [prevdselectjobid, setprevdselectjobid] = useState([])
  const [dSearchEngine, SetdSearchEngine] = useState([])
  const [dCountryHandle, SetdCountryHandle] = useState([])
  const [dStateHandle, SetdStateHandle] = useState([])
  const [dCity, SetdCity] = useState([])
  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2")
  const [initialDateval, SetInitialDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);


  const [freesiteaudit, setfreesiteaudit] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [error, setErrors] = useState({});
  const [summaryData, setSummaryData] = useState({
    difficulty_distribution: {
      "labels": [],
      "counts": [],
      "colors": []
    },
    top_5: [],
    bottom_5: []
  });

  const navigate = useNavigate();

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const columns = [

    // {
    //   field: "keyword",
    //   headerName: "Keywords",
    //   description: 'The list of keywords is provided in campaign settings.',
    //   minWidth: 170,
    //   flex: 1,
    //   disableClickEventBubbling: true,
    //   headerAlign: "center",
    //   align: "center",
    // },
    {
      field: "keyword",
      headerName: "Keywords",
      minWidth: 170,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <Tooltip
          title="The list of keywords is provided in campaign settings."
          placement="bottom"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "rgba(97, 97, 97, 0.92);",
                color: "#fff",
                borderRadius: "4px",
                fontFamily: "Poppins, sans-serif",
                padding: "2px 6px",
                fontSize: "0.687rem",
                fontWeight: "400",
                marginLeft: "100px"
              },
            },
          }}
        >
          <Typography
            style={{
              cursor: "pointer",
              fontSize: "15px",
              fontWeight: 500,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            Keywords
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "intent",
      headerName: "Intent",
      description: "A keyword's total search volume in search results.",
      minWidth: 200,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      valueGetter: (params) => params.row.intent ?? "-"
    },
    {
      field: "search_voume",
      headerName: "SV",
      description: "A keyword's total search volume in search results.",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      valueGetter: (params) => params.row.search_voume ?? null,
    },
    {
      field: "Monthly Searches",
      headerName: "SV Trend",
      description: "The last 12 months' search volume is shown visually as a simple small bar graph for the keyword. ",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (cardData) => {
        var sr = cardData.row.sv_trend.last_month_search_volume;
        if (sr != null && Array.isArray(sr) && sr.length > 0) {
          var monthval = sr.map((item) => {
            const monthName = new Date(item.year, item.month - 1).toLocaleString("en-US", { month: "long" });
            return `${monthName} ${item.year}`;
          });
          var chartdataval = sr.map((item) => item.search_volume);

          return (
            <ChartContainer
              width={200}
              height={150}
              series={[{ data: chartdataval, label: "Search Volume", type: "bar" }]}
              xAxis={[{ scaleType: "band", data: monthval }]}
            >
              <BarPlot />
              <ChartsTooltip />
            </ChartContainer>
          );
        } else {
          return sr;
        }
      },
    },
    {
      field: "difficulty",
      headerName: "Difficulty",
      description: "The Value-Based Display Of Keyword Difficulty For The Respective Keyword",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      valueGetter: (params) => {
        return params.row.difficulty.value;
      },
      renderCell: (cardData) => {
        var sr = cardData.row.difficulty.value;
        return (sr);
      },
    },
    {
      field: "category",
      headerName: "Campaign",
      description: "Campaign names that have been added to the domain.",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
    {
      field: "search_engine",
      headerName: "Search Engine",
      description: "List Of Search Engine Configured In The Campaign Settings",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {


        if (cardData.row.search_engine === 'Bing') {

          return (

            <div className="search_engine_row">
              <img src={BingPng} />{cardData.row.search_engine}

            </div>

          )

        }
        else if (cardData.row.search_engine === 'Google') {

          return (

            <div className="search_engine_row">
              <img src={GooglePng} />{cardData.row.search_engine}
            </div>

          )

        }
        else {

          return (


            cardData.row.search_engine


          )

        }

      }
    },
    {
      field: "location",
      headerName: "Location",
      description: "The list of locations is configured in the campaign settings.",
      minWidth: 230,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        return (

          <>


            <div> {cardData.row.location.country} {cardData.row.location.state ? `,` : ""}<br />
              {cardData.row.location.state}{cardData.row.location.city ? `,` : ""}<br />
              {cardData.row.location.city ? `${cardData.row.location.city}` : ""}</div>
          </>

        )

      }
    },

    {
      field: "prefered_url",
      headerName: "Preferred URL",
      description: 'Shows the URL that ranks for the selected keyword.',
      minWidth: 320,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        let firstEightLetters = cardData?.row?.prefered_url;
        let whoedata = firstEightLetters;
        let baseUrl = cardData.row.prefered_url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.prefered_url.split("/").slice(3).join("/");
        return (
          <>

            <Tooltip title={cardData.row.prefered_url}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.prefered_url} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>

          </>
        )

      }
    },
    {
      field: "position",
      headerName: "Position",
      description: "Ranking Position For The Keyword In Search Results",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      valueGetter: (params) => params.row.position ?? null,

    },
    {
      field: "missed_val",
      headerName: "Missed Opportunity",
      description: "Missed Opportunity Of The Keywords For The Website",
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      valueGetter: (params) => params.row.missed_val ?? null,

    },
    {
      field: "change_in_percent",
      headerName: "Change In Percent",
      description: "The Change In Percent For Missed Opportunity For The Keyword Comparing With The Previous Report",
      minWidth: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (cardData) => {
        if (cardData?.row?.change_in_percent?.change && cardData?.row?.change_in_percent?.change === 'Dropped') {
          return (
            <div className="gain_drop_row" style={{ color: '#ffa6a6' }}>
              <ArrowDropDownIcon />
              <span>{cardData?.row?.change_in_percent?.value}</span>
            </div>
          )
        }
        else if (cardData?.row?.change_in_percent?.change && cardData?.row?.change_in_percent?.change === 'Gained') {
          return (
            <div className="gain_drop_row" style={{ color: '#00ab00' }}>
              <ArrowDropUpSharpIcon />
              <span>{cardData?.row?.change_in_percent?.value}%</span>
            </div>
          )

        }
        else if (cardData?.row?.change_in_percent?.change && cardData?.row?.change_in_percent?.change === 'No Change') {
          return (
            <div className="gain_drop_row no_change_row" style={{ color: 'orange' }}>
              <SquareIcon />
              <span>N/A</span>
            </div>
          )
        }
        else {
          return (
            <div>
              <span>{cardData?.row?.change_in_percent}%</span>
            </div>
          )
        }
      },
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handlechartChange = (event, newValue) => {
    setChartvalue(newValue);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let errors = { ...validation };
  let subtitle;
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  const MyCustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>No Data</Box>
    </StyledGridOverlay>
  );

  const SetCountryHandle = async (value) => {
    SetStateoptions([]);
    SetdStateHandle([])
    SetCity("");
    if (value) {
      SetCountry(value.value);
      try {
        const statedatavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${value.value}&filter_type=state`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });
        if (statedatavalue?.data) {
          if (statedatavalue?.data?.states) {
            var Sections = [];

            statedatavalue.data.states.forEach((element) => {
              Sections.push({ label: element.search_engine_locale__state__state_name, value: element.search_engine_locale__state__id });
            });

            SetStateoptions(Sections);
            SetdStateHandle(Sections[0])
          }
        }

      } catch (err) {
        console.log(err)
      }


    }
  };

  const SetStateHandle = async (value) => {
    SetCityOptions([]);
    SetdCity([])
    SetCity("");

    if (value && value.value !== undefined) {
      SetState(value);
      const citydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${value.value}&filter_type=city`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }

      });

      if (citydatavalue?.data) {
        if (citydatavalue?.data?.cities) {
          var Sections = [];
          citydatavalue.data.cities.forEach((element) => {
            Sections.push({ label: element.search_engine_locale__city__city_name, value: element.search_engine_locale__city__id });
          });
          SetCityOptions(Sections);
          SetdCity(Sections[0])
        }
      }
    }
    else {
      SetState(0);
    }
  };


  const rows = cardData ?? [];
  const finalreportNow = async () => {
    setLoading(true);
    SetErrorMsg("")

    const newErrors = {};

    if (!dcampaignoption) newErrors.dcampaignoption = "Campaign is required.";
    if (!dselectjobid) newErrors.dselectjobid = "Date is required.";
    if (!dSearchEngine) newErrors.dSearchEngine = "Search engine is required.";
    if (!dCountryHandle) newErrors.dCountryHandle = "Country is required.";
    if (!dStateHandle) newErrors.dStateHandle = "State is required.";
    if (!dCity) newErrors.dCity = "City is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }
    setErrors({});

    var StateId = '';
    var CityId = '';

    if (State.value) {
      StateId = State.value
      SetStatedataid(StateId)

    }
    else {
      StateId = 0
      SetStatedataid(0)
    }
    if (City.value) {
      CityId = City.value
      SetCitydataid(CityId)
    }
    else {
      CityId = 0
      SetCitydataid(0)
    }




    if (selectjobid !== "" || campaign !== "" || SearchEngine !== "" || Country !== "" || StateId !== "" || CityId !== "") {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}keywords/v2/missed_opportunity_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectjobid}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${StateId}&city_id=${CityId}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setCardData("");
            SetAutoheightval(true)
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });

      if (datavalue?.data) {
        const dataval = datavalue?.data?.missed_opportunity;

        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setCardData(newData);

      }
      else {
        setCardData("");
        SetAutoheightval(true)
      }
      if (datavalue?.data) {
        setSummaryData({
          difficulty_distribution: {
            "labels": datavalue?.data?.summary_charts?.difficulty_distribution?.labels || [],
            "counts": datavalue?.data?.summary_charts?.difficulty_distribution?.counts || [],
            "colors": datavalue?.data?.summary_charts?.difficulty_distribution?.colors || []
          },
          top_5: datavalue?.data?.summary_charts?.top_5 || [],
          bottom_5: datavalue?.data?.summary_charts?.bottom_5 || []
        })
      }

      setLoading(false);

    }
    setIsOpen(false);
    setprevdselectjobid(dselectjobid);
    setLoading(false);
  }

  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
    setdselectjobid(prevdselectjobid);
  }
  function dataChange(e) {
    let dataval_id = e[0].id
    let fun_name = 1
    calljobiddata(dataval_id, fun_name)
  }
  function datavalChange(e) {
    let dataval_id = e[0].id;
    let fun_name = 2
    calljobiddata(dataval_id, fun_name)
  }
  const calljobiddata = async (dataval_id = "", fun_name = "") => {
    setLoading(true);
    const datedatavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=site_audit&user_domain_id=${dataval_id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      )
      .catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
    setLoading(false)
    if (fun_name == 1)
      setReportdata(datedatavalue.data.jobs)
    else if (fun_name == 2)
      setReporttwodata(datedatavalue.data.jobs)
  }
  useEffect(() => {
    faqdatafun();
  }, []);
  const LoadAddFormFilterOptions = async (jobid = "") => {
    setjobidData([]);
    SetSectionOptions([]);
    SetCountryoptions([]);
    SetEngineoptions([]);
    Setcampaignoption([])
    try {
      const campaigndatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${State}&city_id=${City}&filter_type=campaign`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

      if (campaigndatavalue?.data?.campaigns) {
        if (campaigndatavalue?.data?.campaigns) {
          var campaignSections = [];
          campaigndatavalue.data?.campaigns.forEach((element) => {
            campaignSections.push({ label: element.category__name, value: element.category__id });
          });
          Setcampaignoption(campaignSections);
          Setdcampaignoption(campaignSections[0])
        }
      }
    } catch (err) { }
    try {
      const jobdatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=rankings_summary`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (jobdatavalue?.data?.jobs) {
        if (jobdatavalue?.data?.jobs) {
          // var jobSections = [];
          // jobdatavalue.data.jobs.forEach((element) => {
          //   jobSections.push({ label: datezonechange(element.completed_at), value: element.id });
          // });
          const uniqueByCompletedAt = removeDuplicateDate(jobdatavalue?.data?.jobs);
          if (uniqueByCompletedAt.length > 0)
            setdselectjobid(uniqueByCompletedAt[0])
          setprevdselectjobid(uniqueByCompletedAt[0])
          setjobidData(uniqueByCompletedAt);
        }
      }
    } catch (err) { }
    try {
      const enginedatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${jobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&country_id=${Country}&state_id=${State}&city_id=${City}&filter_type=search_engine`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (enginedatavalue?.data?.search_engines) {
        if (enginedatavalue?.data?.search_engines) {
          var Sections = [];
          enginedatavalue.data.search_engines.forEach((element) => {
            Sections.push({ label: element.search_engine_locale__search_engine__name, value: element.search_engine_locale__search_engine__id });
          });
          SetEngineoptions(Sections);
          SetdSearchEngine(Sections[0])
        }
      }
    } catch (err) { }
    try {
      const countrydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${jobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&state_id=${State}&city_id=${City}&filter_type=country`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (countrydatavalue?.data?.countries) {
        if (countrydatavalue?.data?.countries) {
          var Sections = [];
          countrydatavalue.data.countries.forEach((element) => {
            Sections.push({ label: element.search_engine_locale__country__name, value: element.search_engine_locale__country__id });
          });
          SetCountryoptions(Sections);
          SetdCountryHandle(Sections[0])
          SetdStateHandle(Sections[0])
          SetdCity(Sections[0])
        }
      }
    } catch (err) { }



  };
  const callUserdataApi = async (jobid = "", secondjobid = "") => {
    setLoading(true);
    setTableLoading(true);

    const datavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}keywords/v2/missed_opportunity_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      )
      .catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setCardData("");
          SetAutoheightval(true)
          setapiOpen(true);

          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });


    if (datavalue?.data?.missed_opportunity && datavalue?.data?.missed_opportunity.length > 0) {
      const dataval = datavalue?.data?.missed_opportunity;
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      SetAutoheightval(false)
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);

    }
    else {
      setCardData("");
      SetAutoheightval(true)
    }
    setTableLoading(false);

    if (datavalue?.data) {
      setSummaryData({
        difficulty_distribution: {
          "labels": datavalue?.data?.summary_charts?.difficulty_distribution?.labels || [],
          "counts": datavalue?.data?.summary_charts?.difficulty_distribution?.counts || [],
          "colors": datavalue?.data?.summary_charts?.difficulty_distribution?.colors || []
        },
        top_5: datavalue?.data?.summary_charts?.top_5 || [],
        bottom_5: datavalue?.data?.summary_charts?.bottom_5 || []
      })
    }

    setLoading(false);
  };
  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}keywords/v2/missed_opportunity_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectjobid}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${statedataid}&city_id=${citydataid}&formats=pdf&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("MissedOpportunities", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();



        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}keywords/v2/missed_opportunity_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectjobid}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${statedataid}&city_id=${citydataid}&formats=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("MissedOpportunities", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=10`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };




  const freeAudit = async () => {


    const check = await Utils("missed_opportunities", ApiToken);
    setfreesiteaudit(check);
    if (check.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
    }

  }


  useEffect(() => {

    freeAudit();


  }, [])

  function handleReset() {
    Setdcampaignoption("");
    setdselectjobid("");
    SetdSearchEngine("");
    SetdCountryHandle("");
    SetdStateHandle("");
    SetdCity("");
    setselectjobid("");
  }

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const handleModelPopUp = () => {
    openModal();
  }


  return (

    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Missed Opportunities</title>
      </Helmet>
      {
        loading === true ? <Loader /> : null
      }


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  {pagename}
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Keywords' },
                      { title: 'Missed Opportunities', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px', justifyContent: 'center' }}>

          {summaryData?.difficulty_distribution?.counts.length > 0 &&
            <Grid item xs={12} md={3}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '250px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>UX Distribution</Typography>
                <Chart
                  type="donut"
                  height={200}
                  series={summaryData?.difficulty_distribution?.counts}
                  options={{
                    labels: summaryData?.difficulty_distribution?.labels,
                    colors: summaryData?.difficulty_distribution?.colors,
                    legend: { position: 'bottom', fontSize: '10px' },
                    dataLabels: { enabled: false }
                  }}
                />
              </Box>
            </Grid>
          }

          {summaryData?.top_5.length > 0 &&
            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#2e7d32', marginBottom: '10px' }}>Top 5 URLs</Typography>
                <Chart
                  type="bar"
                  height={200}
                  series={[{ name: "Score", data: summaryData?.top_5.map(i => i.missed_val) }]}
                  options={{
                    chart: { toolbar: { show: false } },
                    plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                    colors: ["#2e7d32"],
                    xaxis: { categories: summaryData?.top_5.map(i => i.prefered_url), labels: { show: false } },
                    dataLabels: { enabled: true, formatter: (val) => `${val}%`, position: 'right' }
                  }}
                />
              </Box>
            </Grid>
          }

          {summaryData.bottom_5.length > 0 &&
            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#d32f2f', marginBottom: '10px' }}>Bottom 5 URLs</Typography>
                <Chart
                  type="bar"
                  height={200}
                  series={[{ name: "Score", data: summaryData.bottom_5.map(i => i.missed_val) }]}
                  options={{
                    chart: { toolbar: { show: false } },
                    plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                    colors: ["#d32f2f"],
                    xaxis: { categories: summaryData.bottom_5.map(i => i.prefered_url), labels: { show: false } },
                    dataLabels: { enabled: true, formatter: (val) => `${val}%`, position: 'right' }
                  }}
                />
              </Box>
            </Grid>
          }

        </Grid>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {freesiteaudit.status ?
                  <DatagridComp className="datagrid_custom_scroll"
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={3}
                    columnFreezeWidth={[0, 170]}
                    tableLoading={tableLoading}
                    customFilter={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                    DownloadShowFile={true}
                    handleDownlodingPDF={handleDownlodingPDF}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleModelPopUp={handleModelPopUp}
                  /> : <Freeaudit planStatus={freesiteaudit} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      <div className="cnt_audit_outer_wrap">
        <div className="">

          {toggle && <Keywordbar close={() => setToggle(false)} setToggle={setToggle} initialDateval={initialDateval} />}

        </div>

        {/* {freesiteaudit.status ?
          <DatagridComp
            columns={columns}
            rows={rows}
            autoheightval={autoheightval}
            datagridval={3}
            columnFreezeWidth={[0, 170]}
            tableLoading={tableLoading}
          /> : <Freeaudit planStatus={freesiteaudit} />
        } */}
      </div>



      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" className="width-auto" style={{ width: "500px" }}>
            <div className="error_plagarism_report">{ErrorMsg}</div>
            <div className="dialog-input-form">
              <div className="row form-black" style={{ gap: "10px" }}>
                <div className="dialog-input-form-width">
                  <label className="form-label">Campaign1</label>
                  <Select
                    value={dcampaignoption}
                    options={campaignoption}
                    placeholder="Select..."
                    onChange={(e) => {
                      Setcampaign(e.value);
                      Setdcampaignoption(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                  {error.dcampaignoption && <div className="customerrormsg">{error.dcampaignoption}</div>}
                </div>
                <div className="dialog-input-form-width">
                  <label className="form-label">Completed Date</label>
                  <Select
                    value={dselectjobid}
                    options={jobidData}
                    placeholder="Select..."
                    onChange={(e) => {
                      setselectjobid(e.value);
                      setdselectjobid(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                  {error.dselectjobid && <div className="customerrormsg">{error.dselectjobid}</div>}
                </div>
              </div>
              <div className="row form-black" style={{ gap: "10px" }}>
                <div className="dialog-input-form-width">
                  <label className="form-label">Search Engine</label>
                  <Select
                    value={dSearchEngine}
                    options={Engineoptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetSearchEngine(e.value);
                      SetdSearchEngine(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                  {error.dSearchEngine && <div className="customerrormsg">{error.dSearchEngine}</div>}
                </div>
                <div className="dialog-input-form-width">
                  <label className="form-label">Country</label>
                  <Select
                    value={dCountryHandle}
                    options={Countryoptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetCountryHandle(e);
                      SetdCountryHandle(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                  {error.dCountryHandle && <div className="customerrormsg">{error.dCountryHandle}</div>}
                </div>
              </div>
              <div className="row form-black" style={{ gap: "10px" }}>
                <div className="dialog-input-form-width">
                  <label className="form-label">State</label>
                  <Select
                    value={dStateHandle}
                    options={Stateoptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetStateHandle(e);
                      SetdStateHandle(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                  {error.dStateHandle && <div className="customerrormsg">{error.dStateHandle}</div>}
                </div>
                <div className="dialog-input-form-width">
                  <label className="form-label">City</label>
                  <Select
                    value={dCity}
                    options={CityOptions}
                    placeholder="Select..."
                    onChange={(e) => {
                      SetCity(e);
                      SetdCity(e)
                    }}
                    styles={customDropdownStyles()}
                    // menuPortalTarget={document.body}
                    className="keyword-select-container"
                  />
                  {error.dCity && <div className="customerrormsg">{error.dCity}</div>}
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={finalreportNow} style={{ cursor: 'pointer' }} >
            Submit
          </button>
          <button className="form_submit_btn" style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}>
            Reset
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="keyword-dialog-header">{"Error Message "}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            No Data Found
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
      {
        !openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <UserActivityTracker pagename="Keywords - Missed Opportunity" />

    </div >
  );
}
